import { __e as __ } from '../../Utils';

export default [
  {
    data: __('ZNAČKA'),
    left: true,
  },
  {
    data: __('PODIEL'),
    center: true,
  },
  {
    data: __('Obrat'),
    right: true,
  },
];



// WEBPACK FOOTER //
// ./src/ContentConfig/Dashboard/brandsTableHeader.js